import axios from "axios";
import { getApiUrl } from "@/shared/utils/api";
import { AUTH_ENDPOINTS } from "../configs/endpoints";
import { deleteAuthInfo, getAccessToken, saveAuthToken } from "./accessToken.service";
import { getAuthDeviceId } from "./localStorage.service";

type GenerateResponse = { login_token: string, expires_in: number };
type ExchangeResponse = { access_token: string, token_type: string, expires_in: number };

export const generateCrossScopeToken = async (): Promise<GenerateResponse> => {
  const accessToken = getAccessToken();
  if (!accessToken) throw new Error("Not authenticated");

  const response = await axios.post<GenerateResponse>(
    getApiUrl(AUTH_ENDPOINTS.GENERATE_CROSS_SCOPE_TOKEN),
    {},
    {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${accessToken}`,
      },
      withCredentials: true,
    },
  );

  return response.data;
};

export const exchangeCrossScopeToken = async (loginToken: string): Promise<ExchangeResponse> => {
  const response = await axios.post<ExchangeResponse>(
    getApiUrl(AUTH_ENDPOINTS.EXCHANGE_CROSS_SCOPE_TOKEN),
    {
      login_token: loginToken,
      direction: "to_representative",
      device_id: getAuthDeviceId(),
    },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    },
  );

  deleteAuthInfo();
  saveAuthToken(response.data.access_token, response.data.expires_in);
  return response.data;
};
